import { useEffect } from 'react'

// The browser tab title. The default (index.html) is plain "DigitalWatch";
// the few pages that name themselves keep it short, with a colon, never a
// dash. Every title lives here so a single test can hold the wording.
export const DEFAULT_TITLE = 'DigitalWatch'

export const PAGE_TITLES = {
  signIn: 'DigitalWatch: sign in',
  clientHome: 'DigitalWatch: your security team',
  smbSignup: 'DigitalWatch: get started',
} as const

export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title
    return () => {
      document.title = DEFAULT_TITLE
    }
  }, [title])
}
